import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class CompanyMortgageAmortization extends ModelBase {
  constructor(dataContext: any) {
    super();
    this.amount = new Money(dataContext.amount.currencyCode, dataContext.amount.amount);
    this.paymentDate = LocalDate.fromDate(dataContext.paymentDate);
    this.companyMortgageId = dataContext.companyMortgageId;
  }

  companyMortgageId: string;
  amount: Money;
  paymentDate: LocalDate;
}
